<script lang="ts">
  interface Props {
    /** Largura em porcento da coluna, ou em pixels quando vier como string. */
    width: string;
    height?: number;
  }

  let { width, height = 12 }: Props = $props();
</script>

<span class="shimmer" style="width: {width}; height: {height}px"></span>

<style>
  .shimmer {
    display: block;
    border-radius: var(--radius-sm);
    background: linear-gradient(
      90deg,
      var(--bg-hover) 25%,
      var(--border-subtle) 37%,
      var(--bg-hover) 63%
    );
    background-size: 400% 100%;
    animation: shimmer 1.4s ease-in-out infinite;
  }

  @keyframes shimmer {
    0% { background-position: 100% 50%; }
    100% { background-position: 0 50%; }
  }
  @media (prefers-reduced-motion: reduce) {
    .shimmer { animation: none; }
  }
</style>
